import "/__w/1/s/BotFramework-WebChat/packages/component/src/Middleware/ActivityGrouping/ui/PartGrouping/private/PartGroupingActivity.module_built.css";
const classes = {"part-grouping-activity__message-status":"wjtNCTG_part-grouping-activity__message-status","part-grouping-activity__collapsible":"wjtNCTG_part-grouping-activity__collapsible","part-grouping-activity__collapsible--open":"wjtNCTG_part-grouping-activity__collapsible--open","part-grouping-activity":"wjtNCTG_part-grouping-activity","part-grouping-activity__activities":"wjtNCTG_part-grouping-activity__activities"}
export default classes

const _part_grouping_activity__message_status0 = classes["part-grouping-activity__message-status"]
export { _part_grouping_activity__message_status0 as "part-grouping-activity__message-status" }

const _part_grouping_activity__collapsible0 = classes["part-grouping-activity__collapsible"]
export { _part_grouping_activity__collapsible0 as "part-grouping-activity__collapsible" }

const _part_grouping_activity__collapsible__open0 = classes["part-grouping-activity__collapsible--open"]
export { _part_grouping_activity__collapsible__open0 as "part-grouping-activity__collapsible--open" }

const _part_grouping_activity0 = classes["part-grouping-activity"]
export { _part_grouping_activity0 as "part-grouping-activity" }

const _part_grouping_activity__activities0 = classes["part-grouping-activity__activities"]
export { _part_grouping_activity__activities0 as "part-grouping-activity__activities" }
